<template>
  <header class="info-content">
     <!-- info mobile -->
    <img :draggable="false" class="content-info mobile" :src="activityImages.mobile.career" alt="" />
    <img :draggable="false" class="content-info mobile" :src="activityImages.mobile.delivery" alt="" />
    <img :draggable="false" class="content-info mobile" :src="activityImages.mobile.learnMore" alt="" />

    <!-- info pc -->
    <img :draggable="false" class="content-info pc" :src="activityImages.web.career" alt="" />
    <img :draggable="false" class="content-info pc" :src="activityImages.web.delivery" alt="" />
    <img :draggable="false" class="content-info pc" :src="activityImages.web.learnMore" alt="" />

   <!-- 关注 -->
    <img
      :draggable="false"
      v-if="!followed"
      class="content-info-subscribe mobile"
      @click="handleSubscribe"
      :src="activityImages.mobile.btnfollow"
    />
    <img
      :draggable="false"
      v-else
      class="content-info-subscribe-un mobile"
      :src="activityImages.mobile.btn_alreayfollow"
    />
     <img
      :draggable="false"
      v-if="!followed"
      class="content-info-subscribe pc"
      @click="handleSubscribe"
      :src="activityImages.web.btnfollow"
    />
    <img
      :draggable="false"
      v-else
      class="content-info-subscribe-un pc"
      :src="activityImages.web.btn_alreayfollow"
    />
    <!-- 投递 -->
    <img
      :draggable="false"
      class="content-info-delivery mobile"
      :src="activityImages.mobile.btn_delivery"
    />
    <img
      :draggable="false"
      class="content-info-delivery pc"
      :src="activityImages.web.btn_delivery"
    />
    <a class="content-info-post" href="https://jobs.bilibili.com/campus/positions?channel=mtcexplain"></a>
  </header>
</template>

<script>
import { onMounted, ref } from 'vue';
import follow from '@bilibili-firebird/kuma/follow';
import activityImages from '../config/images';

export default {
  name: 'App',
  components: {},
  setup() {
    const followed = ref(false);
    onMounted(async () => {
      if (window.kuma.user.isLogin) {
        followed.value = await follow(213899402, true);
      }
    });
    const handleSubscribe = async () => {
      if (followed.value) return;
      const result = await follow(213899402);
      if (!result) {
        throw new Error('关注失败啦！');
      } else {
        followed.value = true;
      }
    };
    return {
      activityImages,
      followed,
      handleSubscribe,
    };
  },
};
</script>

<style lang="less">
.info-content {
  position: relative;
  z-index: 1;
  margin: 0 auto;
  padding: 0;
}
.content-info {
  width: 100%;
}
.content-info-subscribe-un {
  position: absolute;
  bottom: 12.5%;
  width: 20%;
  left: 40%;
  cursor: pointer;
}
.content-info-subscribe {
    position: absolute;
    bottom: 13%;
    width: 20%;
    left: 40%;
    cursor: pointer;
    &:hover {
      transform: translateY(5px);
    }
}
.content-info-delivery {
  position: absolute;
  bottom: 40%;
  width: 27%;
  left: 37%;
  cursor: pointer;
}
.content-info-post {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 56%;
  bottom: 37.5%;
  height: 5%;
  border-radius: 30px;
  cursor: pointer;
}
@media screen and (max-width: 870px) {
  .info-content {
    position: relative;
    z-index: 1;
    max-width: 910px;
    margin: 0 auto;
    padding: 0;
  }
  .content-info-post {
    bottom: 36.5%;
    width: 59%;
    height: 5%;
  }
  .content-info-delivery {
    position: absolute;
    bottom: 36%;
    width: 60%;
    left: 20%;
    cursor: pointer;
  }
  .content-info-subscribe {
    position: absolute;
    bottom: 12%;
    width: 40%;
    left: 29.5%;
    cursor: pointer;
    &:hover {
      transform: translateY(5px);
    }
  }
  .content-info-subscribe-un{
    position: absolute;
    bottom: 12%;
    width: 40%;
    left: 30%;
    cursor: pointer;
  }
}
</style>
